import { useDispatch, useSelector } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import 'tippy.js/dist/tippy.css'; // optional
import { Menu, MenuItem, MenuButton, MenuDivider, MenuHeader } from "@szhsin/react-menu";
import { IoAddCircleOutline,IoArchive,IoLogOutOutline, IoHome } from "react-icons/io5";
import  AvatarProfile  from "../components/Avatar/AvatarProfile";
import Avatar from '@mui/material/Avatar';
import { selectCurrentUser, selectCurrentUserRoles, logout, selectAuthentificated, setAuthUser, setAuthentificated, setToken, login } from "../auth/AuthUserSlice";
import orangeLogo from "../resources/img/orange_logo.jpg";
import anonymPic from "../resources/img/anonyme_pic.png";

import {useTranslation} from "react-i18next";
import { LanguageSelector } from "../components/Language/LanguageSelector";
import { useEffect } from "react";
import { useKeycloak } from "@react-keycloak/web";


const Navbar = () => {

  const dispatch = useDispatch();
  const isAuthentificated = useSelector(selectAuthentificated); 
  const currentUser = useSelector(selectCurrentUser);
  const currentUserRoles = useSelector(selectCurrentUserRoles);
  // Using Object destructuring
  const { keycloak, initialized } = useKeycloak();
  const {t} = useTranslation("common");
  const navigate = useNavigate();


  useEffect(() => {
      
  }, []);

  const openProfile = () => {
    navigate('/account');
  }

  const openParameters = () => {
    navigate('/parametres');
  }


  const currentRegister = () => {
    keycloak.register();
  };

  const currentLogin = () => {
      keycloak.login();
  };

  const currentLogout = () => {
    console.log('Logout SUCCESS');
    dispatch(logout());
    keycloak.logout();
  };
  
  return (
    <>
        <header>
            <nav role="navigation" className="navbar navbar-dark navbar-expand-md supra" aria-label="Complementary navigation">
                <div className="container">
                    <LanguageSelector />
                </div>
            </nav>
            <nav role="navigation" className="navbar navbar-expand-lg navbar-dark">
                  <NavLink 
                    className={"navbar-brand"}
                    to={"/"}
                  >
                    <img src={orangeLogo} className="d-inline-block align-bottom mr-3 ml-20" alt="Logo Orange" title="Back to homepage" width="100" height="100"/>
                    <span className="h1 m-0">Fondation</span>
                  </NavLink>
                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                  <span className="navbar-toggler-icon"></span>
                </button>
              
                <div className="collapse navbar-collapse w-100" id="navbarSupportedContent">
                  <ul className="navbar-nav ml-auto mr-6 main-menu">
                    
                    <li className="nav-item">
                      <NavLink 
                        className={"nav-link"}
                        to={"/"}
                      >
                        { t('app.home') }  <span className="sr-only">(current)</span>
                      </NavLink>
                    </li>
                    {  !!isAuthentificated &&
                      ( <>
                            {/* <li className="nav-item">
                              <NavLink 
                                  className={"nav-link"}
                                  to={"/new/projects/1"}
                                >
                                { 'Introduire une demande' } 
                              </NavLink>
                            </li> */}
                            <li className="nav-item">
                              <NavLink 
                                  className={"nav-link"}
                                  to={"/list/projects"}
                                >
                                { t('account.myProject') } 
                              </NavLink>
                            </li>
                            <li className="nav-item" style={{ marginTop: "-5px" }} >
                                <Menu
                                  direction={"bottom"}
                                  arrow={true}
                                  menuButton={
                                  <AvatarProfile cuid={currentUser?.preferred_username} />
                                }>
                                  <MenuHeader className={"profile-item"}>
                                  <Avatar className="avatar_menu" src="/broken-image.jpg" alt={currentUser?.preferred_username} sx={{ bgcolor:"#FF7800"}} />
                                    <div style={{ fontSize: "10px" }}>
                                        <div> {currentUser?.preferred_username}  </div>
                                        {/* <div > ADCM \ {currentUser?.preferred_username} </div> */}
                                    </div>
                                  </MenuHeader>
                                  <MenuDivider />
                                  <MenuItem onClick={() => openProfile() }>
                                    <span>{ t('account.myProfile') }</span>
                                  </MenuItem>
                                  {/* <MenuItem onClick={() => openParameters() }>
                                    <span>{ ('Paramètre') }</span>
                                  </MenuItem> */}
                                  <MenuItem onClick={() => currentLogout() }>
                                    <IoLogOutOutline /><span>{ t('app.logout') }</span>
                                  </MenuItem>
                                </Menu>
                            </li>
                        </>
                       )
                    } 
                    {  !isAuthentificated &&
                        <>
                          <li >
                            {/* <NavLink 
                                className={"nav-link btn btn-secondary"}
                                to={"/register"}
                              >
                              { 'CREER UN COMPTE' } 
                            </NavLink> */}
                            <button className="nav-link btn btn-secondary uppercase" onClick={() => currentRegister() }>{ t('app.signin') }</button>
                          </li>
                          <li>
                            <button className="nav-link btn btn-primary uppercase" onClick={() => currentLogin() }>{ t('app.login') }</button>
                          </li>
                        </>
                    }
                  </ul>
                </div>
            </nav>
        </header>
    </>
  )
};

export default Navbar;
